import React from 'react';
import rpcShared from '@rockpapercoin/rpc-shared';
import styles from './InvoiceEditRemainingBalance.module.scss';
import { gql, DocumentNode } from '@apollo/client';
import { Box, Typography } from '@mui/material';
import { InvoiceEditRemainingBalanceInvoiceFragment } from '#types';

const invoiceEditRemainingBalanceInvoiceFragment = gql`
	fragment invoiceEditRemainingBalanceInvoice on Invoice {
		discountAmount
		lineItems {
			id
			name
			quantity
			rate
			taxPercentage
		}
		paymentInstallments {
			amountDue
			status
			paymentDate
		}
	}
`;

export type InvoiceEditRemainingBalanceProps = {
	invoice?: Omit<InvoiceEditRemainingBalanceInvoiceFragment, 'id'> & {
		id?: string;
	};
};

type InvoiceEditRemainingBalancePropsWithFragment =
	React.FC<InvoiceEditRemainingBalanceProps> & {
		fragments: {
			invoiceEditRemainingBalanceInvoiceFragment: DocumentNode;
		};
	};

export const InvoiceEditRemainingBalance: InvoiceEditRemainingBalancePropsWithFragment =
	( { invoice } ) => {
		const subtotal = invoice
			? rpcShared.invoices.calculateInvoiceTotal( invoice )
			: 0;
		const sumAmountDue =
			invoice?.paymentInstallments?.reduce(
				( acc, paymentInstallment ) => acc + ( paymentInstallment?.amountDue || 0 ),
				0
			) ?? 0;
		const remainingBalance = rpcShared.invoices.numberToCurrency(
			subtotal - sumAmountDue
		);
		const valueIsNegative = /\(/.test( remainingBalance );
		const className = [ styles.text, ...( valueIsNegative ? [ styles.negative ] : [] ), ].join( ' ' );
		return (
			<Box className={ styles.container }>
				<Typography className={ className }>Remaining balance:</Typography>
				<Typography className={ className } data-cy='remaining balance'>
					{ remainingBalance }
				</Typography>
			</Box>
		);
	};

InvoiceEditRemainingBalance.fragments = {
	invoiceEditRemainingBalanceInvoiceFragment,
};
